import { render } from "./mButton.vue?vue&type=template&id=769847a2"
import script from "./mButton.vue?vue&type=script&lang=js"
export * from "./mButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__